import React from "react";

const Social = () => {
  return (
    <div className="home__social">
      <a
        href="https://www.instagram.com/mohamed.chouati_/"
        className="home__social-icon"
        target="_blank">
        <i class="uil uil-instagram"></i>
      </a>

      <a
        href="https://www.linkedin.com/in/mohamed-chouati-249798198/"
        className="home__social-icon"
        target="_blank">
        <i class="uil uil-linkedin"></i>
      </a>

      <a
        href="https://github.com/MohamedCh99"
        className="home__social-icon"
        target="_blank">
        <i class="uil uil-github-alt"></i>
      </a>

      <a
        href="https://www.upwork.com/freelancers/~014d26d9cc42bfd63f"
        className="home__social-icon"
        target="_blank">
        <i class="bx bxl-upwork"></i>
      </a>
    </div>
  );
};

export default Social;
